/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Tooltip, Modal, DialogContent } from '@mui/material';
import Alert from '@mui/material/Alert';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles, withStyles } from '@mui/styles';
import { NetworkStatus, useLazyQuery, useQuery } from '@apollo/client';

import * as Q from '../../../../../../constants/graphqlQueries';
import colors from '../../../../../../constants/colors';

import CustomTextField from '../../../../../components/Textfield/CustomTextField';
import CustomDropdown from '../../../../../components/Dropdown/CustomDropdown';
import CustomButtons from '../../../../../components/Button/CustomButtons';
import SwitchCustom from '../../../../../Switch/SwitchCustom';
import ModalDetail from '../../../../../ModalDetail/ModalDetail';

import './DimensionRC.css';

const useStyles = makeStyles({
  alert: {
    fontSize: '1rem',
    color: colors.danger
  }
});
const StyledTooltip = withStyles({
  arrow: {
    color: '#F9F9F9'
  },
  tooltip: {
    backgroundColor: '#F9F9F9',
    color: colors.black,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.35)',
    padding: '1.3rem'
  }
})(Tooltip);

const agentValidationError = 'Notifications will only reach employees via Zoom, an existing TTEC email address is required.';
const optionsSwitch = {
  agent: {
    rightTitle: 'Agent'
  },
  GA: {
    rightTitle: 'G&A'
  },
  groupChat: {
    rightTitle: 'Group Chat'
  }
};
const ThresholdErrorMessages = {
  maximum: 'The Maximum value must be greater than the minimum',
  minimum: 'The Minimum value must be lower than the maximum',
  negative: 'Negative numbers are not a valid option',
  twentyFourHours: 'This value cannot exceed 24 hours (in minutes)'
};
const noZoomChannelsFoundMessage = 'There are no Zoom Channels available, Group Chat option is not available';
const flagFrequencyOptions = [
  { minutes: '5' },
  { minutes: '10' },
  { minutes: '15' },
  { minutes: '30' },
];
const MINIMUM = '0';
const MAXIMUM = '1440';

const FieldIndex = {
  ruleName: 1, ACDStatus: 2, minimumThreshold: 3, maximumThreshold: 4, flagFrequency: 5, usersToBeNotified: 6, userMessage: 7, groupChat: 8
};
const buttonOption = {
  save: 'Save',
  next: 'Next'
};
const modalOptions = { title: 'Choose rule default status: ' }

const modalRestrictOption = {
  title: 'Restricted action',
  description: 'The rule you are trying to create already exists',
}

const DimensionPerformance = ({ handleDimensionSubmit, handleBack, codeTypes, dimensionPreview, ruleToEdit }) => {
  const classes = useStyles();
  const [buttonName, setButtonName] = useState(buttonOption.save);
  const [inputFieldDisabled, setInputFieldDisabled] = useState(0);
  const [ruleName, setRuleName] = useState('');
  const [ACDSelected, setACDSelected] = useState();
  const [minimumThresholdSelected, setMinimumThresholdSelected] = useState('');
  const [maximumThresholdSelected, setMaximumThresholdSelected] = useState('');
  const [flagFrequencySelected, setFlagFrequencySelected] = useState();
  const [agentToggleSelected, setAgentToggleSelected] = useState(false);
  const [agentNotification, setAgentNotification] = useState('');
  const [GAToggleSelected, setGAToggleSelected] = useState(false);
  const [GANotification, setGANotification] = useState('');
  const [openRuleDuplicatedModal, setOpenRuleDuplicatedModal] = useState(false);
  const [ruleNameDuplicated, setRuleNameDuplicated] = useState([]);
  const [groupChatStatus, setGroupChatStatus] = useState(false);
  const [channels, setChannels] = useState({});
  const [selectedChannel, setSelectedChannel] = useState();

  const [thresholdValidationError, setThresholdValidationError] = useState({ maximum: { state: false, message: '' }, minimum: { state: false, message: '' } });

  const [ACDStatusData, setACDStatusData] = useState({});
  const [flagFrequency, setFlagFrequency] = useState({});

  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);

  const { data: ACDStatus } = useQuery(Q.ACD_STATE);
  const [getIsRuleDuplicated, { data: dataRuleIsDuplicated, networkStatus: dataRuleIsDuplicatedNetworkStatus }] = useLazyQuery(Q.VALIDATE_PERFORMANCE_RULE_DUPLICATED, { notifyOnNetworkStatusChange: true });
  const { data: zoomChannelsData } = useQuery(Q.GET_ZOOM_CHANNELS);

  const handleCloseRuleDuplicatedModal = () => {
    setOpenRuleDuplicatedModal(false);
  }
  const handleRuleName = (value) => setRuleName(value);
  const handleACDStatus = (item) => setACDSelected(item);
  const handleMinimum = (value) => {
    if (value) {
      if (value > Number(maximumThresholdSelected) && maximumThresholdSelected || value === '') {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, minimum: { state: true, message: value > Number(maximumThresholdSelected) && maximumThresholdSelected ? ThresholdErrorMessages.minimum : '' } });
      }
      else {
        const maximumErrorMessage = maximumThresholdSelected < 0 ? ThresholdErrorMessages.negative : maximumThresholdSelected > 1440 ? ThresholdErrorMessages.twentyFourHours : maximumThresholdSelected === '' ? '' : '';
        setThresholdValidationError({ maximum: { state: maximumErrorMessage ?? false, message: maximumErrorMessage }, minimum: { state: false, message: '' } });
      }

      // Cannot be negative nor exceed 24 hours limit
      if (value < 0 || value > 1440) {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, minimum: { state: true, message: value < 0 ? ThresholdErrorMessages.negative : ThresholdErrorMessages.twentyFourHours } });
      }
    }
    setMinimumThresholdSelected(value.replace(/^0+/, ''));
  };
  const handleMaximum = (value) => {
    if (value) {
      if (value < Number(minimumThresholdSelected) && minimumThresholdSelected || value === '') {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, maximum: { state: true, message: value < Number(minimumThresholdSelected) && minimumThresholdSelected ? ThresholdErrorMessages.maximum : ThresholdErrorMessages.isNull } });
      }
      else {
        const minimumErrorMessage = minimumThresholdSelected < 0 ? ThresholdErrorMessages.negative : minimumThresholdSelected > 1440 ? ThresholdErrorMessages.twentyFourHours : minimumThresholdSelected === '' ? ThresholdErrorMessages.isNull : '';
        setThresholdValidationError({ minimum: { state: minimumErrorMessage ?? false, message: minimumErrorMessage }, maximum: { state: false, message: '' } });
      }

      // Cannot be negative nor exceed 24 hours limit
      if (value < 0 || value > 1440) {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, maximum: { state: true, message: value < 0 ? ThresholdErrorMessages.negative : ThresholdErrorMessages.twentyFourHours } });
      }
    }
    setMaximumThresholdSelected(value.replace(/^0+/, ''));
  };
  const handleFlagFrequency = (item) => setFlagFrequencySelected(item);
  // Toggles status
  const handleToggleAgent = (checked) => {
    if (!checked) setAgentNotification('');
    setAgentToggleSelected(checked);
  };
  const handleNotificationAgent = (value) => setAgentNotification(value);
  const handleToggleGA = (checked) => {
    if (!checked) setGANotification('');
    setGAToggleSelected(checked);
  };
  const handleNotificationGA = (value) => setGANotification(value);

  const handleGroupChat = (checked) => {
    setGroupChatStatus(checked);
    if (!checked) {
      setSelectedChannel('');
    }
  }

  const handleChannel = (item) => {
    setSelectedChannel(item)
  }

  const handleCancel = (isRestart) => {
    setRuleName('');
    setACDSelected(null);
    setMaximumThresholdSelected('');
    setMinimumThresholdSelected('');
    setFlagFrequencySelected(null);
    setAgentToggleSelected(false);
    setAgentNotification('');
    setGAToggleSelected(false);
    setGANotification('');
    setSelectedChannel();
    setGroupChatStatus(false);
    if (isRestart) handleBack('Cancel');
  };

  const submitDimensionData = async (status=null) => {
    const dimensionPerformanceData = [{
      ruleName,
      agentStatus: 1,
      ACDOption: ACDSelected.Label,
      ACDCodeMappingId: ACDSelected.ACDCodeMappingId,
      minimum: minimumThresholdSelected,
      maximum: maximumThresholdSelected,
      flagFrequency: flagFrequencySelected.minutes,
      agent_status: !agentToggleSelected ? 0 : 1,
      agent_Notification: agentNotification,
      GA_status: !GAToggleSelected ? 0 : 1,
      GA_Notification: GANotification,
      isActive: status,
      Channel: selectedChannel || null
    }];
    setOpenModal(false);
    handleDimensionSubmit(dimensionPerformanceData);
  };

  const validateRuleName = () => {
    if (codeTypes) submitDimensionData();
    else  {
      setLoadingSubmit(true);
      let validationParams = { ACDStatus: ACDSelected.Label, RuleName: ruleName }

      if (ruleToEdit) {
        validationParams = { ...validationParams, RuleId: ruleToEdit }
      }

      getIsRuleDuplicated({
            variables: {
              ...validationParams
            }
          });
    }
  }

  const sendingData = () => {
    if (!ruleToEdit) setOpenModal(true);
    else submitDimensionData();
  }
  const isInputFieldDisabled = (inputIndex) => {
    if (inputFieldDisabled && inputIndex > inputFieldDisabled) {
      return true;
    };
    return false;
  }

  const handleClickSave = () => {
    validateRuleName();
  }

  useEffect(() => {
    if (ruleNameDuplicated.length) {
      setOpenRuleDuplicatedModal(true);
    }
  }, [ruleNameDuplicated]);

  useEffect(() => {
    const flagFrequencyProps = {
      options: flagFrequencyOptions,
      getOptionLabel: (option) => option.minutes
    };
    setFlagFrequency(flagFrequencyProps);
  }, []);

  useEffect(() => {
    if (ACDStatus) {
      const ACDStatusProps = {
        options: ACDStatus.getAllACDCodeMapping,
        getOptionLabel: option => option.Label
      }
      setACDStatusData(ACDStatusProps);
    }
  }, [ACDStatus]);

  useEffect(() => {
    if (codeTypes) {
      setButtonName(buttonOption.next);
      setInputFieldDisabled(FieldIndex.ACDStatus);
      handleCancel();
    } 
    else {
      setButtonName(buttonOption.save);
    }
  }, [codeTypes]);

  useEffect(() => {
    if ((dimensionPreview.length && Object.keys(ACDStatusData).length && Object.keys(channels).length) && ruleToEdit) {
      setRuleName(dimensionPreview[0].ruleName);
      setACDSelected({ Label: dimensionPreview[0].ACDOption || '', ACDCodeMappingId: dimensionPreview[0].ACDCodeMappingId });
      setMinimumThresholdSelected(dimensionPreview[0].minimum);
      setMaximumThresholdSelected(dimensionPreview[0].maximum);
      setFlagFrequencySelected({ minutes: String(dimensionPreview[0].flagFrequency) });

      if (dimensionPreview[0].agent_status === 1) {
        setAgentToggleSelected(true);
        setAgentNotification(dimensionPreview[0].agent_Notification);
      }

      if (dimensionPreview[0].GA_status === 1) {
        setGAToggleSelected(true);
        setGANotification(dimensionPreview[0].GA_Notification);
      }

      if (dimensionPreview[0].Channel) {
        setGroupChatStatus(true);
        setSelectedChannel(dimensionPreview[0].Channel);
      }
      setLoadingScreen(false);
    }
  }, [dimensionPreview, ACDStatusData, channels, ruleToEdit]);

  useEffect(() => {
    // State watcher
    if (!ruleName && !codeTypes) setInputFieldDisabled(FieldIndex.ruleName);
    else if (!ACDSelected) setInputFieldDisabled(FieldIndex.ACDStatus);
    else if (!minimumThresholdSelected) setInputFieldDisabled(FieldIndex.minimumThreshold);
    else if (!maximumThresholdSelected || thresholdValidationError.maximum.state || thresholdValidationError.minimum.state) setInputFieldDisabled(FieldIndex.maximumThreshold);
    else if (!flagFrequencySelected) setInputFieldDisabled(FieldIndex.flagFrequency);
    else if (agentToggleSelected && agentNotification === '') setInputFieldDisabled(FieldIndex.usersToBeNotified);
    else if (GAToggleSelected && GANotification === '') setInputFieldDisabled(FieldIndex.usersToBeNotified);
    else if (!agentToggleSelected && !GAToggleSelected && !selectedChannel) setInputFieldDisabled(FieldIndex.usersToBeNotified);
    else setInputFieldDisabled(null);
  }, [codeTypes, ruleName, ACDSelected, minimumThresholdSelected, maximumThresholdSelected, flagFrequencySelected, 
    agentToggleSelected, GAToggleSelected, agentNotification, GANotification, groupChatStatus, selectedChannel]);

  useEffect(() => {
    if (inputFieldDisabled === null) setSubmitDisabled(false);
    else setSubmitDisabled(true);
  }, [inputFieldDisabled]);

  useEffect(() => {
    if (dataRuleIsDuplicated && dataRuleIsDuplicatedNetworkStatus === NetworkStatus.ready) {
      if (dataRuleIsDuplicated.duplicatedPerformanceRuleValidation) {
        if (!(dataRuleIsDuplicated.duplicatedPerformanceRuleValidation.result)) {
          sendingData();
        }
        else if (ruleNameDuplicated !== dataRuleIsDuplicated.duplicatedPerformanceRuleValidation.details) {
          setRuleNameDuplicated(dataRuleIsDuplicated.duplicatedPerformanceRuleValidation.details);
        }
        else if (ruleNameDuplicated.length) {
          setOpenRuleDuplicatedModal(true);
        }
      }

      setLoadingSubmit(false);
    }
  }, [dataRuleIsDuplicated, dataRuleIsDuplicatedNetworkStatus]);

  useEffect(() => {
    if (ruleToEdit) setLoadingScreen(true);
  }, [ruleToEdit]);

  useEffect(() => {
    if (zoomChannelsData) {
      let channelProps = {
        options: [{ Name: 'No channels available' }],
        getOptionLabel: (option) => option.Name
      }

      if (zoomChannelsData.getZoomChannels.length) {
        channelProps = {
          options: zoomChannelsData.getZoomChannels,
          getOptionLabel: (option) => option.Name
        }
      }
      setChannels(channelProps);
    }
  }, [zoomChannelsData]);

  return (
    <>
      <div className='dimension__wrapper'>
        <div className='dimension__wrapper__performance'>
          {!codeTypes && (
            <CustomTextField
              title='Rule Name'
              value={ruleName}
              handleChange={handleRuleName}
              placeholder='Input text'
              mandatory
              loading={loadingScreen}
              maxLength={25}
            />
          )}
          <CustomDropdown
            title='ACD State'
            value={ACDSelected}
            handleChange={handleACDStatus}
            defaultProps={ACDStatusData}
            disabled={isInputFieldDisabled(FieldIndex.ACDStatus)}
            mandatory
            loading={loadingScreen}
          />
          <CustomTextField
            title='Minimum Threshold (in minutes)'
            value={minimumThresholdSelected}
            handleChange={handleMinimum}
            placeholder='Input minutes'
            disabled={isInputFieldDisabled(FieldIndex.minimumThreshold)}
            type='number'
            min={MINIMUM}
            max={MAXIMUM}
            mandatory
            loading={loadingScreen}
          />
          {
            thresholdValidationError.minimum.state && <Alert
              className={classes.alert}
              severity='warning'>
              {thresholdValidationError.minimum.message}
            </Alert>
          }
          <CustomTextField
            title='Maximum Threshold (in minutes)'
            value={maximumThresholdSelected}
            handleChange={handleMaximum}
            placeholder='Input minutes'
            disabled={isInputFieldDisabled(FieldIndex.maximumThreshold)}
            type='number'
            min={MINIMUM}
            max={MAXIMUM}
            mandatory
            loading={loadingScreen}
          />
          {
            thresholdValidationError.maximum.state && <Alert
              className={classes.alert}
              severity='warning'>
              {thresholdValidationError.maximum.message}
            </Alert>
          }
        </div>
        <div className='dimension__wrapper__performance'>
          <CustomDropdown
            title='Flag Frequency (in minutes)'
            value={flagFrequencySelected}
            handleChange={handleFlagFrequency}
            defaultProps={flagFrequency}
            disabled={isInputFieldDisabled(FieldIndex.flagFrequency)}
            mandatory
            loading={loadingScreen}
          />
          {loadingScreen ? <Skeleton /> :
            <p className='tagging__wrapper__autocomplete__title'>Users to be notified</p>
          }
          <SwitchCustom
            switchStatus={agentToggleSelected}
            options={optionsSwitch.agent}
            handleSwitch={handleToggleAgent}
            disabledStatus={isInputFieldDisabled(FieldIndex.usersToBeNotified)}
            loading={loadingScreen}
          />
          <Box style={{ display: !agentToggleSelected ? 'none' : '' }}>
            <StyledTooltip title={agentValidationError}
              placement='top'
              enterDelay={400}
              leaveDelay={200}
              arrow>
              <div>
                <CustomTextField
                  value={agentNotification}
                  handleChange={handleNotificationAgent}
                  placeholder='Input text message'
                  multiline
                  rows={2}
                  maxLength={100}
                />
              </div>
            </StyledTooltip>
          </Box>
          <SwitchCustom
            switchStatus={GAToggleSelected}
            options={optionsSwitch.GA}
            handleSwitch={handleToggleGA}
            disabledStatus={isInputFieldDisabled(FieldIndex.usersToBeNotified)}
            loading={loadingScreen}
          />
          <Box style={{ display: !GAToggleSelected ? 'none' : '' }}>
            <CustomTextField
              value={GANotification}
              handleChange={handleNotificationGA}
              placeholder='Input text message'
              multiline
              rows={2}
              maxLength={100}
            />
          </Box>
          <SwitchCustom
            switchStatus={groupChatStatus}
            options={optionsSwitch.groupChat}
            handleSwitch={handleGroupChat}
            disabledStatus={isInputFieldDisabled(FieldIndex.usersToBeNotified) || !(zoomChannelsData && zoomChannelsData?.getZoomChannels.length)}
          />
          {
            !isInputFieldDisabled(FieldIndex.usersToBeNotified) && !(zoomChannelsData?.getZoomChannels.length) &&
            <Alert
              className={classes.alert}
              severity='warning'>
                {noZoomChannelsFoundMessage}
            </Alert>
          }
          <Box style={{ display: !groupChatStatus ? 'none' : '' }}>
            <CustomDropdown
              title='Channels'
              value={selectedChannel}
              handleChange={handleChannel}
              defaultProps={channels}
              disabled={!groupChatStatus}
            />
          </Box>
        </div>
      </div>
      <div className='create__wrapper_btn_performance'>
        <CustomButtons
          handleClick={() => handleCancel(true)}
          name='Cancel'
          loading={loadingScreen}
        />
        {codeTypes &&
          <CustomButtons
            handleClick={handleBack}
            name='Back'
          />
        }
        <CustomButtons
          handleClick={handleClickSave}
          name={buttonName}
          disabled={submitDisabled}
          tooltipFree
          loadingButton={loadingSubmit}
          loading={loadingScreen}
        />
      </div>
      <Modal
        aria-labelledby='restricted-modal-title'
        aria-describedby='restricted-modal-description'
        open={openRuleDuplicatedModal}
        onClose={handleCloseRuleDuplicatedModal}
      >
        <DialogContent>
          <ModalDetail modalOptions={modalRestrictOption}>
            <div className='restricted-modal-container'>
              <ul className='restricted-modal-list'>
                <li key={ruleNameDuplicated}>
                    {ruleNameDuplicated}
                </li>
              </ul>
            </div>
            <button className='simple-modal-btn' type='button' onClick={handleCloseRuleDuplicatedModal}>Ok</button>
          </ModalDetail>
        </DialogContent>
      </Modal>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={openModal}
      >
        <DialogContent>
          <ModalDetail
            modalOptions={modalOptions}>
            <button className='simple-modal-btn' type='button' onClick={() => submitDimensionData(true)}>Active</button>
            <button className='simple-modal-btn' type='button' onClick={() => submitDimensionData(false)}>Paused</button>
          </ModalDetail>
        </DialogContent>
      </Modal>
    </>
  )
};

DimensionPerformance.propTypes = {
  handleDimensionSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  codeTypes: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dimensionPreview: PropTypes.array.isRequired,
  ruleToEdit: PropTypes.number
};

DimensionPerformance.defaultProps = {
  ruleToEdit: null
};

export default DimensionPerformance
